import { JSON_SCHEMA_CLIENT } from 'services/API';
import { Endpoints } from 'UI/constants/endpoints';

/**
 * @param {Object} data
 */
export const saveReference = (data, options) => {
  return JSON_SCHEMA_CLIENT.post(`/${Endpoints.ReferenceCheck}`, data, {
    ...options
  });
};

/**
 * @param {string} referenceId
 */
export const getSchemasByReferenceId = (referenceId, options) => {
  return JSON_SCHEMA_CLIENT.get(`/${Endpoints.ReferenceCheck}`, {
    params: {
      id: referenceId
    },
    ...options
  });
};

/**
 * @param {Object} data
 */
export const updateReference = (data, referenceId, options) => {
  return JSON_SCHEMA_CLIENT.patch(`/${Endpoints.ReferenceCheck}?id=${referenceId}`, data, {
    ...options
  });
};

/**
 * @param {string} referenceId
 */
export const deleteReference = referenceId => {
  return JSON_SCHEMA_CLIENT.delete(`/${Endpoints.ReferenceCheck}?id=${referenceId}`);
};

/**
 * @param {string} candidateId
 */
export const getReferencesByCandidateId = (candidateId, options) => {
  return JSON_SCHEMA_CLIENT.get(`/${Endpoints.ReferenceCheckByCandidate}`, {
    params: {
      id: candidateId,
      direction: 'desc',
      orderBy: 'created',
      page: 1,
      perPage: 10,
      cache: false
    },
    ...options
  });
};
